import { FC } from 'react';
import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const numberInputSx = {
  flex: 1,
  '& input[type=number]::-webkit-outer-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '& input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
} as const;

export type RecipeActivityRuntimeFieldProps = {
  value: number | undefined;
  onInputChange: (raw: string) => void;
  showResetButton: boolean;
  onResetToRecipe: () => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  maxWidth?: number;
  /** When nested inside DetailField, omit duplicate label and outer spacing. */
  embedded?: boolean;
};

/** Editable activity runtime (hours) with optional reset-to-recipe control. */
export const RecipeActivityRuntimeField: FC<RecipeActivityRuntimeFieldProps> = ({
  value,
  onInputChange,
  showResetButton,
  onResetToRecipe,
  disabled = false,
  error = false,
  helperText,
  maxWidth = 280,
  embedded = false,
}) => (
  <Box sx={{ mb: embedded ? 0 : 2, maxWidth: embedded ? '100%' : maxWidth, width: embedded ? '100%' : undefined }}>
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
      <TextField
        label={embedded ? undefined : 'Runtime (h)'}
        aria-label={embedded ? 'Runtime (h)' : undefined}
        type="number"
        size="small"
        value={value ?? ''}
        onChange={(e) => onInputChange(e.target.value)}
        disabled={disabled}
        error={error}
        helperText={helperText}
        fullWidth={embedded}
        sx={numberInputSx}
        inputProps={{
          step: 0.01,
          min: 0,
        }}
      />
      {showResetButton ? (
        <Tooltip title="Reset to recipe calculated runtime">
          <IconButton
            size="small"
            onClick={onResetToRecipe}
            disabled={disabled}
            aria-label="Reset to recipe calculated runtime"
            sx={{ mt: helperText ? 0.5 : 0.5 }}
          >
            <RestartAltIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
  </Box>
);
